import MainLayout from "../../layout";

const Dashbaord = () => {
  return (
    <MainLayout>
      <p>Dashbaord</p>
    </MainLayout>
  );
};

export default Dashbaord;
